import { createFetcher } from '@kcuf/fetcher';
import interceptBiz from '@kcuf/fetcher-interceptor-biz';
import interceptCacheLocal from '@kcuf/fetcher-interceptor-cache-local';
// import interceptMerging from '@kcuf/fetcher-interceptor-merging'; // FIXME 暂时与 login 冲突
import interceptSls from '@kcuf/fetcher-interceptor-sls';
import { SLS_OPTIONS } from '@lcai/console-sls';
import getUrlBase from './get-url-base';
export default function createFetcherBase() {
  var fetcher = createFetcher({
    urlBase: getUrlBase(),
    headers: {
      'Content-Type': 'application/json'
    }
  });
  interceptBiz(fetcher, {
    isSuccess: function isSuccess(o) {
      return String(o.code) === '0';
    },
    getMessage: function getMessage(o) {
      return o.msg;
    }
  });
  interceptCacheLocal(fetcher); // 必须在 Biz 之后，因为 biz 结果的处理影响缓存的数据
  // interceptMerging(fetcher); // 必须在 CacheLocal 之后，因为 CacheLocal 有类似的逻辑，且 cache 会优先于 merger
  interceptSls(fetcher, SLS_OPTIONS);
  return fetcher;
}
//# sourceMappingURL=create-fetcher-base.js.map